import React, { useEffect  , useState } from 'react'
import { Box, Grid, Paper, Typography, CircularProgress, TextField , Button , MenuItem , Autocomplete } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ApiService from "../../functions/apiService";
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MyTable from '../../components/Schedule/MyTable';
import Pagination from '@mui/material/Pagination';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';

const ShiftAllocationReport = () => {
    let navigate = useNavigate();
    const ReqComponent = () => <span className='text-danger '>*</span>
    const [rows, setRows] = useState([]);
    const [loading , setLoading] = useState(false)
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [fromDateDefault, setFromDateDefault] = useState(null);
    const [toDateDefault, setToDateDefault] = useState(null);
    const [employess , setEmployees] = useState([])
    const [selectedEmpCode, setSelectedEmpCode] = useState(null);
    const [page, setPage] = useState(1);
    const rowsPerPage = 100;
		const [sortDrop, setSortDrop] = useState("");
		const [sortType, setSortType] = useState("DESC");

    const columns = [
        { field: 'Shift_Date', headerName: 'Shift Date', flex: 1 , maxWidth: 180, 
					valueGetter: (params) => {return moment(params?.row?.Log_Time).format('MM/DD/YYYY HH:mm');} 
        },
        { field: 'user', headerName: 'User', flex: 1 , maxWidth: 250,
					valueGetter: (params) => {return params?.row?.Log_Emp;} 
				},
        { field: 'log_by_user', headerName: 'Log By User', flex: 1, maxWidth: 250,
					valueGetter: (params) => {return params?.row?.Log_By_Emp;}
					// valueGetter: (params) => {return params?.row?.log_by_emp?.employee_assignment?.EA_Rank == null ? '' : params?.row?.log_by_emp?.employee_assignment?.EA_Rank + " " + params?.row?.log_by_emp?.fullName;} 
					// (params?.row?.log_by_emp?.employee_assignment?.EA_Rank == null ? '' : params?.row?.log_by_emp?.employee_assignment?.EA_Rank + ' ') + (params?.row?.log_by_emp?.fullName || '')
				},
        { field: 'message', headerName: 'Message', flex: 1,
					valueGetter: (params) => {return params?.row?.Log_Text}

				},
    ];

		const sortOptions = [
    { label: "Shift Date (↑)", value: "1", order: "Shift_Date", sort: "ASC" },
    { label: "Shift Date (↓)", value: "2", order: "Shift_Date", sort: "DESC" },
  	]

    const backFunction = () => {
        navigate('/firehouse/reports')
    }

    const getShiftAllocationReport = async () => {
        setLoading(true);
				const body = {
						'Start_Date': fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
						'End_Date	': toDate ? moment(toDate).format('YYYY-MM-DD'): null,
						'Order_By' : sortType,
					}
        // ApiService.get("/exportShiftLogReport", body)
        // .then(({ data }) => {
        //     setLoading(false);
				// 		setFromDateDefault(data?.Start_Date)
				// 		setToDateDefault(data?.End_Date)
        //     const responseData = data?.data || {};
        //     const formattedRows = Object.entries(responseData).map(([key, value], index) => ({
        //         id: index, 
        //         ...value,
        //     }));
        //     setRows(formattedRows);
        // })
        // .catch((err) => {
        //     toast.error(err?.response?.data?.message || 'Failed to fetch data');
        //     setLoading(false);
        // });
				try {
						const { data } = await ApiService.get("/exportShiftLogReport", body);
						setLoading(false);
						setFromDateDefault(data?.Start_Date);
						setToDateDefault(data?.End_Date);
						const responseData = data?.data || {};
						const formattedRows = Object.entries(responseData).map(([key, value], index) => ({
								id: index,
								...value,
						}));
						setRows(formattedRows);
				} catch (err) {
						toast.error(err?.response?.data?.message || 'Failed to fetch data');
						setLoading(false);
				}
    };

		console.log(fromDateDefault, "From")
		console.log(toDateDefault, "To")

    useEffect(()=>{
        getShiftAllocationReport()
    } , [toDate, sortType])

    // useEffect(() =>{
    //     ApiService.get('/employeeToSwap').then(({ data }) => {
    //         setEmployees(data)
    //     }).catch(() => {
    //         console.error('error')
    //     })
    // } , [])

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    const filteredRows = selectedEmpCode
        ? rows.filter(row =>
            row.Emp_Code === selectedEmpCode.Emp_Code ||
            row.Orig_Emp_Code === selectedEmpCode.Emp_Code
        )
    : rows;

    const paginatedRows = filteredRows.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const downloadCsv = () => {
        if (!filteredRows || filteredRows.length === 0) {
            toast.warning('No data to download.');
            return;
        }

        const headers = Object.keys(filteredRows[0]);

        const csv = [
            headers.join(','),
            ...filteredRows.map(row =>
                headers.map(field => {
                    let value = row[field];
                    if (field === 'Shift_Date' && value) {
                        value = moment(value).format('MM/DD/YYYY') + '.';
                    }
                    return JSON.stringify(value ?? '');
                }).join(',')
            )
        ].join('\n');

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'shift-allocation-report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Paper className='p-4' sx={{ marginTop: '1rem' }}>
            <Box>
                <Button className=' text-decoration-none px-0' onClick={backFunction} style={{ color: '#555555' }}> <ArrowBackIosIcon /> Back</Button>
            </Box>
            <Typography variant="h6" className='mt-1'>Shift Allocation Report</Typography> 

            <div className="mt-1">
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <label style={{ fontSize: "14px" }}>
                            Start Date <ReqComponent />
                        </label>
                        <Box className="mt-1 d-grid">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                           					className='w-100'
																		label={fromDate ? moment(fromDate).format('MM/DD/YYYY') : fromDateDefault ? moment(fromDateDefault).format('MM/DD/YYYY') : ""}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e)}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                    <Grid item xs={3} >
                        <label style={{ fontSize: "14px" }}>
                            End Date <ReqComponent />
                        </label>
                        <Box className="mt-1 d-grid">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                           					className='w-100'
                                    value={toDate}
																		label={toDate ? moment(toDate).format('MM/DD/YYYY') : toDateDefault ? moment(toDateDefault).format('MM/DD/YYYY') : ""}
                                    onChange={(e) => setToDate(e)}
																		maxDate={new Date()}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    
									 <Grid item xs={3}>
										  <label style={{ fontSize: "14px" }}>
                            Sort By
                        </label>
											<TextField
												className="mt-1 w-100"
												select
												label="Sort By"
												variant="outlined"
												color="secondary"
												size="small"
												value={sortDrop}
												onChange={(e) => {
													const selected = sortOptions.find(opt => opt.value === e.target.value);
													setSortDrop(e.target.value);
													setSortType(selected?.sort);
												}}
												placeholder="Sort By"
												InputProps={{
													sx: {
														height: '48px',
														fontSize: '14px'
													},
												}}
												InputLabelProps={{
													sx: {
														marginTop: '4px',
														fontSize: "14px"
													},
												}}
												sx={{
													width: "100%",
													"& .MuiInputBase-root": {
														height: "48px",
														fontSize: "1rem",
														display: "flex",
														alignItems: "center",
														justifyContent: "center"
													},
													"& .MuiFormLabel-root": {
														marginTop: "4px"
													},
													"& .MuiInputLabel-shrink": {
														marginTop: "0px"
													}
												}}
											>
												{sortOptions.map((option) => (
													<MenuItem key={option.value} value={option.value}>
														{option.label}
													</MenuItem>
												))}
											</TextField>
										</Grid>

                    {filteredRows.length > 0 &&
											<Grid item xs={3} sx={{marginTop:'30px' , display:'flex' , justifyContent:'end'}}>
													<ButtonTheme type="submit" 
															variant="filled" color="primary"  onClick={downloadCsv}>
																Download Report
													</ButtonTheme>
											</Grid>}
                </Grid>
            </div>

            {loading && 
                <Box className="w-100 d-flex justify-content-center align-items-center font-fam mt-5" style={{height: 445}}>
                    <CircularProgress />
                </Box>
            }

            {filteredRows.length === 0 && !loading &&
                 <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 495 }}>
										<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
										<span className='mt-4' style={{ color: '#555555' }}>
												No Reports Found
										</span>
								</div>
            }

            {filteredRows.length > 0 && !loading && (
                <div className="mt-3">
                    <MyTable
                        rows={paginatedRows}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                    <div className="mt-4" style={{display:'flex' , justifyContent:'end'}}>
                        <Pagination
                            count={Math.ceil(filteredRows.length / rowsPerPage)}
                            page={page}
                            onChange={handleChangePage}
                            color="primary"
                        />
                    </div>
                </div>
            )}
        </Paper>
  )
}

export default ShiftAllocationReport

{/* <Grid item xs={3}>
<label style={{ fontSize: "14px" }}>
Employees
</label>
<Autocomplete
className="mt-1 w-100"
options={employess || []}
getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
value={selectedEmpCode}
onChange={(event, newValue) => setSelectedEmpCode(newValue)}
renderInput={(params) => (
<TextField
{...params}
variant="outlined"
size="small"
InputProps={{
...params.InputProps,
sx: {
height: '48px',
fontSize: '14px',
},
}}
InputLabelProps={{
sx: {
marginTop: '3px',
fontSize: '14px',
},
}}
/>
)}
isOptionEqualToValue={(option, value) => option.Emp_Code === value.Emp_Code}
/>
</Grid> */}